/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import initialState from './initial-state';

const startPageSlice = createSlice({
    name: 'startPage',
    initialState: initialState(),
    reducers: {
        initialize: (_state, { payload }) => {
            return initialState(payload);
        },
        setStartPageConfigAction: (state, { payload }) => {
            state.config = payload.config;
            state.status = payload.status;
        },
        setStartPageConfigStatusAction: (state, { payload }) => {
            state.status = payload.status;
        }
    }
});

export const {
    initialize,
    setStartPageConfigAction,
    setStartPageConfigStatusAction
} = startPageSlice.actions;

export default startPageSlice.reducer;
